import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import HubSpotContactList from "./HubSpotContactList";
import { ModalPickerProps } from "../props";

const HubSpotContactModalPicker = (props: ModalPickerProps<server.dto.HubSpotContact>) => {
  const onChange = (value: server.dto.HubSpotContact) => {
    props.nonInPageEditing?.onChange(value);
    props.inPageEditing?.onChange(value, true);
  };
  return <ModalPickerWithChooseButton
    onNewClicked={() => { }}
    buttonLabel={"Link with HubSpot contact"}
    modalTitle={"HubSpot contacts"}
    modalSize="tiny"
    renderModalContent={(closeModal) => <HubSpotContactList
      onItemSelected={(contact) => {
        closeModal();
        onChange(contact);
      }}
    />}
    renderRemovable={() => <></>}

    {...props}
  />;
};

export default HubSpotContactModalPicker;